const firebaseConfig = {
    apiKey: "AIzaSyD14qlEw1yaGjYVd70GU6S4jUgZzB3buOA",
    authDomain: "collaborationcommunity-acb34.firebaseapp.com",
    projectId: "collaborationcommunity-acb34",
    storageBucket: "collaborationcommunity-acb34.appspot.com",
    messagingSenderId: "348677266559",
    appId: "1:348677266559:web:a9a04306951b2694cd734a"
  };

export default firebaseConfig;